<template>
  <div v-show="show">
    <loading :loading="loading"></loading>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="onRefresh"
      ></refresh-item>

    <file-download
      :download="download"
      :link="pdfFileOrUrl"
      :save-file="false"
      @fileDownloaded="fileDownloaded"
      @fileNotDownloaded="fileNotDownloaded"
      fileExtension="pdf"
      ></file-download>

    <div
      class="pdf-pages-div"
      v-show="!showRefreshItem">
      <canvas
        id="canvas1"
        v-show="visibleCanvas1"
        ></canvas>
      <canvas
        id="canvas2"
        v-show="visibleCanvas2"
        ></canvas>
      <canvas
        id="canvas3"
        v-show="visibleCanvas3"
        ></canvas>
      <canvas
        id="canvas4"
        v-show="visibleCanvas4"
        ></canvas>
      <canvas
        id="canvas5"
        v-show="visibleCanvas5"
        ></canvas>
      <canvas
        id="canvas6"
        v-show="visibleCanvas6"
        ></canvas>
      <canvas
        id="canvas7"
        v-show="visibleCanvas7"
        ></canvas>
      <canvas
        id="canvas8"
        v-show="visibleCanvas8"
        ></canvas>
      <canvas
        id="canvas9"
        v-show="visibleCanvas9"
        ></canvas>
      <canvas
        id="canvas10"
        v-show="visibleCanvas10"
        ></canvas>
      <canvas
        id="canvas11"
        v-show="visibleCanvas11"
        ></canvas>
      <canvas
        id="canvas12"
        v-show="visibleCanvas12"
        ></canvas>
      <canvas
        id="canvas13"
        v-show="visibleCanvas13"
        ></canvas>
      <canvas
        id="canvas14"
        v-show="visibleCanvas14"
        ></canvas>
      <canvas
        id="canvas15"
        v-show="visibleCanvas15"
        ></canvas>
      <canvas
        id="canvas16"
        v-show="visibleCanvas16"
        ></canvas>
      <canvas
        id="canvas17"
        v-show="visibleCanvas17"
        ></canvas>
      <canvas
        id="canvas18"
        v-show="visibleCanvas18"
        ></canvas>
      <canvas
        id="canvas19"
        v-show="visibleCanvas19"
        ></canvas>
      <canvas
        id="canvas20"
        v-show="visibleCanvas20"
        ></canvas>

      <div v-if="showPdfActionDivision">
        <div
          v-if="consentNeeded"
          class="item-row-alignment margin_top_20 horizontal_center item-cursor"
          @click="onConsentSelected">
          <weex-image
            :src="checkboxImage"
            class="ezcred-checkbox-image"
            ></weex-image>
          <weex-text class="ezcred-checkbox-text">{{ consentText }}</weex-text>
        </div>

        <wxc-button
          v-if="consentNeeded && !consentChecked"
          :text="continueButtonText"
          :btn-style="continueDisabledButtonStyle"
          :text-style="continueDisabledTextStyle"
          size="full"
          class="button_horizontal_center margin_top_20 margin-bottom-20">
        </wxc-button>

        <wxc-button
          v-else
          :text="continueButtonText"
          size="full"
          class="button_horizontal_center margin_top_20 margin-bottom-20"
          type="blue"
          @wxcButtonClicked="onContinueClicked">
        </wxc-button>
      </div>
    </div>
  </div>
</template>

<script>

  import WxcButton from "../../../weex-ui/packages/wxc-button/index";
  import FileDownload from "../layout/FileDownload";
  import Loading from "./Loading";
  import RefreshItem from "./RefreshItem";
  import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";
  import PDFJS from "pdfjs-dist/build/pdf.js";

  export default {
    name: "ShowPDFItem",
    components: { FileDownload, WxcButton, Loading, RefreshItem },
    data: () => ({
      pdfFileOrUrl: "",
      pdfViewPortWidth: 0,
      isUrl: true,
      loading: false,
      showRefreshItem: false,
      download: false,
      pdfFile: "",
      showPdfActionDivision: false,
      consentChecked: false,
      visibleCanvasses: {},
      visibleCanvas1: false,
      visibleCanvas2: false,
      visibleCanvas3: false,
      visibleCanvas4: false,
      visibleCanvas5: false,
      visibleCanvas6: false,
      visibleCanvas7: false,
      visibleCanvas8: false,
      visibleCanvas9: false,
      visibleCanvas10: false,
      visibleCanvas11: false,
      visibleCanvas12: false,
      visibleCanvas13: false,
      visibleCanvas14: false,
      visibleCanvas15: false,
      visibleCanvas16: false,
      visibleCanvas17: false,
      visibleCanvas18: false,
      visibleCanvas19: false,
      visibleCanvas20: false
    }),

    props: {
      show: {
        type: Boolean,
        required: true,
        default: false
      },
      consentNeeded: {
        type: Boolean,
        default: false
      },
      consentText: {
        type: String,
        default: ""
      },
      continueButtonText: {
        type: String,
        default: "Continue"
      }
    },

    methods: {
      onContinueClicked() {
        this.$emit("onContinue");
      },

      resetData() {
        this.loading = false;
        this.showRefreshItem = false;
        this.download = false;
        this.pdfFile = "";
        this.showPdfActionDivision = false;
        this.consentChecked = false;

        for (let i = 1; i <= 20; i++) {
          this["visibleCanvas" + i] = false;
        }
      },

      onConsentSelected() {
        this.consentChecked = !this.consentChecked;
      },

      showPdfFile(pdfFileOrUrl, isUrl) {
        this.resetData();
        this.pdfFileOrUrl = pdfFileOrUrl;
        this.isUrl = isUrl;
        if (isUrl) {
          this.download = true;
          this.loading = true;
        } else {
          this.pdfFile = pdfFileOrUrl;
          this.showFile();
        }
      },

      onRefresh() {
        this.showPdfFile(this.pdfFileOrUrl, this.isUrl);
      },

      showFile() {
        const outerContext = this;
        if (this.pdfFile) {
          const loadingTask = PDFJS.getDocument(this.pdfFile);

          loadingTask.promise.then(function (doc) {
            const numPages = doc.numPages;

            let lastPromise; // will be used to chain promises
            lastPromise = doc.getMetadata().then(function (data) {
              // console.log(JSON.stringify(data.info, null, 2));
              if (data.metadata) {
                // console.log(JSON.stringify(data.metadata.getAll(), null, 2));
              }
            });

            let loadPage = function (pageNum) {
              return doc.getPage(pageNum)
                .then(function (page) {
                  let viewport = page.getViewport({ scale: 1.0 });
                  let canvas = document.getElementById("canvas" + pageNum);
                  let context = canvas.getContext("2d");
                  const devicePixelRatio = window.devicePixelRatio || 1;
                  outerContext.pdfViewPortWidth = viewport.width;
                  canvas.style.width =
                    outerContext.contentWidth(window.innerWidth, viewport.width) + "px";
                  canvas.style.height = viewport.height;
                  canvas.width = viewport.width * devicePixelRatio;
                  canvas.height = viewport.height * devicePixelRatio;
                  const transform = [devicePixelRatio, 0, 0, devicePixelRatio, 0, 0];

                  let renderContext = {
                    canvasContext: context,
                    viewport: viewport,
                    transform: transform
                  };

                  page.render(renderContext).then(function () {
                    outerContext.visibleCanvasses["canvas" + pageNum] = true;
                    outerContext["visibleCanvas" + pageNum] = true;
                    console.log("Page rendered!");
                  });

                  return page.getTextContent()
                    .then(function (content) {
                      // Content contains lots of information about the text layout and
                      // styles, but we need only strings at the moment
                      let strings = content.items.map(function (item) {
                        return item.str;
                      });
                    })
                    .catch(function () {
                      console.log();
                    });
                });
            };
            // Loading of the first page will wait on metadata and subsequent loadings
            // will wait on the previous pages.
            for (let i = 1; i <= numPages; i++) {
              lastPromise = lastPromise.then(loadPage.bind(null, i));
            }
            return lastPromise;
          })
            .then(
              function () {
                console.log("# End of Document");
                outerContext.showPdfActionDivision = true;
                outerContext.loading = false;
              },
              function (err) {
                console.error("Error: " + err);
                outerContext.loading = false;
                outerContext.showRefreshItem = true;
              }
            );
        } else {
          this.loading = false;
        }
      },

      fileDownloaded(e) {
        this.download = false;
        this.pdfFile = URL.createObjectURL(e.bufferUrl);
        this.showFile();
      },

      fileNotDownloaded() {
        this.showRefreshItem = true;
        this.loading = false;
        this.download = false;
      },

      contentWidth(width1, width2) {
        let width = width1;
        if (width2 && width2 > 0) {
          if (width && width > 0) {
            if (width2 < width) {
              width = width2;
            }
          } else {
            width = width2;
          }
        }
        return width && width > 0 ? width : 450;
      },
    },

    computed: {
      checkboxImage() {
        return this.consentChecked
          ? ImageResourcesUtil.getImageLink(ImageResourcesUtil.CHECKED_CHECKBOX)
          : ImageResourcesUtil.getImageLink(ImageResourcesUtil.UNCHECKED_CHECKBOX);
      },

      continueDisabledButtonStyle() {
        return { "background-color": "#D0D0D0" }
      },

      continueDisabledTextStyle() {
        return { color: "#FFFFFF" }
      }
    }
  }
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>

<style scoped>
  .pdf-pages-div {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 70px;
    bottom: 0;
  }
</style>
